import React from 'react';
import { Tooltip, TooltipProps, tooltipClasses } from '@mui/material';
import { styled } from '@mui/material/styles';

const DarkTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip
    placement="top"
    {...props}
    classes={{ popper: className }}
    disableTouchListener={false}
    enterTouchDelay={0}
  />
))(() => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#000000',
    opacity: '1 !important',
    color: '#ffffff !important',
    // boxShadow: theme.shadows[1],
    fontSize: '14px',
    fontFamily: 'Poppins',
    lineHeight: '20px',
    letterSpacing: '0.25px',
    maxWidth: 331,
    fontWeight: 300,
    boxShadow: '-1px 1px 8px 1px rgb(0 0 0 / 17%)',
    padding: '8px 12px',
    borderRadius: '4px',
    '& span': {
      // top: '4px !important',
      '&:before': {
        backgroundColor: '#000000',
        // opacity: '0.7 !important',
        // backgroundImage: `url(${Images.toop_tip_arrow_white})`
      },
    },
  },
}));

const LightTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip
    placement="top"
    {...props}
    classes={{ popper: className }}
    disableTouchListener={false}
    enterTouchDelay={0}
  />
))(() => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#FFFFFF',
    color: '#233E76',
    // boxShadow: theme.shadows[1],
    fontSize: '14px',
    fontFamily: 'Roboto',
    lineHeight: '20px',
    letterSpacing: '0.25px',
    maxWidth: 331,
    fontWeight: 300,
    boxShadow: '-1px 1px 8px 1px rgb(0 0 0 / 17%)',
    padding: '8px 12px',
    borderRadius: '4px',
    '& span': {
      // top: '4px !important',
      '&:before': {
        backgroundColor: '#FFFFFF',
        // backgroundImage: `url(${Images.toop_tip_arrow_white})`
      },
    },
  },
}));

const ErrorTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip
    {...props}
    classes={{ popper: className }}
    disableTouchListener={false}
    enterTouchDelay={0}
  />
))(() => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#dc362e',
    color: '#ffffff',
    // boxShadow: theme.shadows[1],
    fontSize: '14px',
    fontFamily: 'Roboto',
    lineHeight: '20px',
    letterSpacing: '0.25px',
    maxWidth: 331,
    fontWeight: 400,
    boxShadow: '-1px 1px 8px 1px rgb(0 0 0 / 17%)',
    padding: '8px 12px',
    borderRadius: '4px',
    '& span': {
      // top: '4px !important',
      '&:before': {
        backgroundColor: '#dc362e',
        // backgroundImage: `url(${Images.toop_tip_arrow_white})`
      },
    },
  },
}));
interface Props {
  title?: string | React.ReactNode;
  children: React.ReactElement;
  arrow?: boolean;
  theme?: 'dark' | 'light' | 'error';
  isLink?: boolean;
  position?: TooltipProps['placement'];
  PopperProps?: TooltipProps['PopperProps'];
}

const ToolTipComponent: React.FC<Props> = props => {
  const { title, children, arrow, theme, position, PopperProps } = props;
  // Omitting `placement` lets each themed tooltip fall back to its own
  // default (top) — only override it when a caller explicitly asks for one.
  const placementProps = position ? { placement: position } : {};
  return (
    <>
      {theme === 'light' ? (
        <LightTooltip
          title={title}
          arrow={arrow ? true : false}
          PopperProps={PopperProps}
          {...placementProps}
        >
          {children}
        </LightTooltip>
      ) : theme === 'error' ? (
        <ErrorTooltip
          title={title}
          arrow={arrow ? true : false}
          PopperProps={PopperProps}
          {...placementProps}
        >
          {children}
        </ErrorTooltip>
      ) : (
        <DarkTooltip
          title={title}
          arrow={arrow ? true : false}
          PopperProps={PopperProps}
          {...placementProps}
        >
          {children}
        </DarkTooltip>
      )}
    </>

    // <Tooltip title={title} arrow>
    //   {children}
    // </Tooltip>
  );
};

export default ToolTipComponent;
